import { useLocation } from 'react-router-dom';

/**
 * Hook pour déterminer le chemin de base du workspace actuel.
 * Gère les 3 modes: workspace personnel, projet, et invité (guest).
 * 
 * Retourne le préfixe de route à utiliser pour la navigation interne.
 * Exemples:
 *   - /workspace (mode personnel)
 *   - /projects/5/workspace (mode projet)
 *   - /guest-workspace/14 (mode invité)
 */
const useWorkspaceBasePath = () => {
  const location = useLocation();
  
  // Mode invité: /guest-workspace/:ownerId/...
  const guestMatch = location.pathname.match(/^\/guest-workspace\/(\d+)/);
  if (guestMatch) {
    return `/guest-workspace/${guestMatch[1]}`;
  }
  
  // Mode projet: /projects/:id/workspace/...
  const projectMatch = location.pathname.match(/^\/projects\/(\d+)\/workspace/);
  if (projectMatch) {
    return `/projects/${projectMatch[1]}/workspace`;
  }
  
  // Mode personnel par défaut
  return '/workspace';
};

export default useWorkspaceBasePath;
